import { ListItemBox } from "lib/@components/ListItemBox.js"
import { Box, Stack } from "@mui/material"
import { isSpecial } from "routes/schedule/tree/schedules/isSpecial.js"
import Iconify from "minimals-template/components/Iconify.js"
import { TruncatedTypography } from "lib/@components/truncated-typography.js"
import { If } from "lib/@components/if.js"

export function ScheduleItemImage({ schedule }) {
    return (
        <ListItemBox sx={{ p: 2, bgcolor: "action.selected" }}>
            <Box
                sx={{
                    fontWeight: isSpecial(schedule.label) ? "bold" : undefined,
                    mr: 1,
                    lineHeight: 0,
                }}
            >
                <Iconify icon="mdi:file-document-outline" sx={{ width: 32, height: 32 }} />
            </Box>
            <Stack flex={1} sx={{ overflow: "hidden", minWidth: 0 }}>
                <Box
                    flex={1}
                    overflow={"hidden"}
                    sx={{
                        fontWeight: isSpecial(schedule.label) ? "bold" : undefined,
                    }}
                >
                    <Box display="flex" alignItems="center">
                        <TruncatedTypography data-cy="schedule-item-title">
                            {schedule.label ?? schedule.title}
                        </TruncatedTypography>
                    </Box>
                </Box>
            </Stack>
            {/* mirrors the code presentation on a schedule selector row, minus the tailoring-aware ScheduleCode */}
            <If truthy={schedule.code}>
                <TruncatedTypography
                    variant="caption"
                    data-cy="selected-schedule-code"
                    sx={{ ml: 2, whiteSpace: "nowrap" }}
                >
                    #{schedule.code}
                </TruncatedTypography>
            </If>
        </ListItemBox>
    )
}
